'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var search = function search(el) {
  (0, _classCallCheck3.default)(this, search);

  (0, _jquery2.default)('[data-open-search-modal]').click(function (e) {
    (0, _jquery2.default)('.mod-Modal[data-modal=' + (0, _jquery2.default)(this).data('modal') + ']').addClass('mod-Modal-open');
    setTimeout(function () {
      (0, _jquery2.default)('.mod-Modal input').focus();
    }, 300);

    (0, _jquery2.default)('body').addClass('no-scroll');
    event.preventDefault();
  });

  // Close Modal
  (0, _jquery2.default)('[data-closeModal=search_modal]').click(function () {
    (0, _jquery2.default)('.mod-Modal').removeClass('mod-Modal-open');
    (0, _jquery2.default)('body').removeClass('no-scroll');
    (0, _jquery2.default)('.mod-Modal input').blur();
    event.preventDefault();
  });

  // Click outside of modal to close
  (0, _jquery2.default)(document).click(function (e) {
    if ((0, _jquery2.default)(e.target).is('.mod-Modal[data-modal=search]')) {
      e.preventDefault();
      (0, _jquery2.default)('.mod-Modal').removeClass('mod-Modal-open');
      (0, _jquery2.default)('.mod-Modal input').blur();
      (0, _jquery2.default)('body').removeClass('no-scroll');
    }
  });
};

exports.default = search;